import getUrls from "../api";
import BaseDataService from "./base-data-service";

class RecordsFilesService extends BaseDataService {
    getRecordInfos = async () => {
        let url = new URL(this.uri.baseUrl);
        const reqRes = await fetch(url).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Couldn't get record files data");
        });

        return reqRes;
    };
}

const prepareRecordsFilesService = basepath => {
    const { originPath } = getUrls(basepath);
    let baseUrl = originPath + "api/records/";
    // Signal service_________________________
    let signalService;
    signalService = new RecordsFilesService(baseUrl);

    return signalService;
};
export default prepareRecordsFilesService;
